/** Local overrides for token icons that ship remote URLs from the wallet plugin. */
const TOKEN_ICON_OVERRIDES: Record<string, string> = {
  NIGHT: "/icons/night.svg",
  "P.NIGHT": "/icons/night.svg",
};

/**
 * Resolves the display icon for a token symbol.
 * Prefer local overrides (e.g. NIGHT) over plugin-provided remote URLs.
 */
export function resolveTokenIcon(symbol: string, icon?: string | null): string {
  const normalized = symbol.replace(/^p\./i, "p.").toUpperCase();
  const base = normalized.replace(/^P\./, "");
  return (
    TOKEN_ICON_OVERRIDES[normalized] ||
    TOKEN_ICON_OVERRIDES[base] ||
    icon ||
    "coti"
  );
}
